define("calendar/components/calendar/settings/bttp/upgrade", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <p class="u--text--success" data-test-id="bttp-upgrade">
    {{svg-jar "verified" class="o--icon o--icon--success u--m__r__xs"}}
    {{t "bttp.eligible"}}
  </p>
  
  <p class="u--text--light">
    {{#if (or @rolloutBttpV3 @isInstagram)}}
      {{html-safe (t "bttp.toggle_details_2")}}
    {{else}}
      {{html-safe (t "bttp.toggle_details")}}
      <Shared::Link @href={{this.learnMoreLink}} @text={{t "shared_phrases.learn_more"}} />
    {{/if}}
  </p>
  
  <Shared::Ui::Button @onClick={{perform @triggerBttp true}} @variant="outline">
    {{svg-jar "bttp" class="o--icon u--m__r__xs"}}
    {{t "bttp.generate"}}
  </Shared::Ui::Button>
  
  <Shared::CollapsableInfoCard @title={{t "bttp.improved_feature"}}>
    <ul>
      <li>{{t "bttp.no_minimum_posts"}}</li>
      <li>{{t "bttp.more_accurate_timeslots"}}</li>
    </ul>
  </Shared::CollapsableInfoCard>
  */
  {
    "id": "ySzGRJTE",
    "block": "[[[10,2],[14,0,\"u--text--success\"],[14,\"data-test-id\",\"bttp-upgrade\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"verified\"],[[\"class\"],[\"o--icon o--icon--success u--m__r__xs\"]]]],[1,\"\\n  \"],[1,[28,[35,1],[\"bttp.eligible\"],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,2],[14,0,\"u--text--light\"],[12],[1,\"\\n\"],[41,[28,[37,3],[[30,1],[30,2]],null],[[[1,\"    \"],[1,[28,[35,4],[[28,[37,1],[\"bttp.toggle_details_2\"],null]],null]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,4],[[28,[37,1],[\"bttp.toggle_details\"],null]],null]],[1,\"\\n    \"],[8,[39,5],null,[[\"@href\",\"@text\"],[[30,0,[\"learnMoreLink\"]],[28,[37,1],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n\"]],[]]],[13],[1,\"\\n\\n\"],[8,[39,6],null,[[\"@onClick\",\"@variant\"],[[28,[37,7],[[30,3],true],null],\"outline\"]],[[\"default\"],[[[[1,\"\\n  \"],[1,[28,[35,0],[\"bttp\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n  \"],[1,[28,[35,1],[\"bttp.generate\"],null]],[1,\"\\n\"]],[]]]]],[1,\"\\n\\n\"],[8,[39,8],null,[[\"@title\"],[[28,[37,1],[\"bttp.improved_feature\"],null]]],[[\"default\"],[[[[1,\"\\n  \"],[10,\"ul\"],[12],[1,\"\\n    \"],[10,\"li\"],[12],[1,[28,[35,1],[\"bttp.no_minimum_posts\"],null]],[13],[1,\"\\n    \"],[10,\"li\"],[12],[1,[28,[35,1],[\"bttp.more_accurate_timeslots\"],null]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]]]],[\"@rolloutBttpV3\",\"@isInstagram\",\"@triggerBttp\"],false,[\"svg-jar\",\"t\",\"if\",\"or\",\"html-safe\",\"shared/link\",\"shared/ui/button\",\"perform\",\"shared/collapsable-info-card\"]]",
    "moduleName": "calendar/components/calendar/settings/bttp/upgrade.hbs",
    "isStrictMode": false
  });
  let UpgradeComponent = _exports.default = (_dec = (0, _service.inject)('calendar/bttp'), (_class = class UpgradeComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "bttp", _descriptor, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor2, this);
    }
    get learnMoreLink() {
      return this.bttp.learnMoreLink(this.selectedSocialProfiles.firstProfile?.profileType);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "bttp", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, UpgradeComponent);
});